import React from 'react';
import './withFmlxRowErrors.scss';
import { ErrorIcon } from '@fmlx/icons';
import { HexColors } from 'constants/colors';

type CellArgs = {
  value?: React.ReactNode;
  row?: { original?: any };
  column?: RowErrorColumn;
};

type ColumnWithCell = {
  Cell?: (args: CellArgs) => React.ReactNode;
};

type RowErrorColumn = {
  originalCell?: (args: CellArgs) => React.ReactNode;
  getRowErrorMessage?: (row: any) => string | undefined;
};

const RowErrorCell = (args: CellArgs) => {
  const { originalCell, getRowErrorMessage } = args.column ?? {};
  const content = originalCell ? originalCell(args) : args.value;
  const message = getRowErrorMessage?.(args.row?.original ?? {});
  if (!message) {
    return <>{content}</>;
  }

  return (
    <div
      data-fmlx-row-error="true"
      title={message}
      className="flex flex-row items-center gap-1"
    >
      <ErrorIcon customColor={HexColors.red[1]} className="h-4 w-4 shrink-0" />
      <div className="min-w-0 flex-1">{content}</div>
    </div>
  );
};

export function withFmlxRowErrors<TColumn extends ColumnWithCell>(
  columns: TColumn[],
  getMessage: (row: any) => string | undefined,
): TColumn[] {
  if (!columns.length) {
    return columns;
  }

  const [first, ...rest] = columns;
  return [
    {
      ...first,
      Cell: RowErrorCell,
      originalCell: first.Cell,
      getRowErrorMessage: getMessage,
    },
    ...rest,
  ];
}
